export default __webpack_public_path__ + "40844110a74238322fc89cb09515bdb1.png";